// Create a new file: components/JusticeLoader/JusticeLoader.js
import React from 'react';
import './JusticeLoader.scss';
import gavelmain from '../../assets/images/gavel-main.png'

const JusticeLoader = ({ message = "Loading...", type = "gavel" }) => {
  if (type === "hammer") {
    return (
      <div className="loading-container">
        <div className="hammer-loader">
          <div className="hammer">🔨</div>
          <div className="anvil">🪨</div>
          <div className="loading-text">{message}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="loading-container">
      <div className="justice-loader">
        <div className="gavel"><img src={gavelmain} alt='gavel' className='gavel-img'/></div>
        <div className="loading-text">{message}</div>
      </div>
    </div>
  );
};

export default JusticeLoader;